export default __webpack_public_path__ + "static/media/VISA.227d6e84.svg";